import { useContext } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { USER_EMAIL } from '../constants'
import { AuthContext } from '../context'
import PageNotFound from '../pages/404'
import { LoginRouteState, SessionEndReason, getStoredToken, getToken } from '../utils'
import { AUTH_LINKS } from '../constants'

/**
 * Login is checked first, then the role. `allowed` is the role check; leave it out for pages
 * every logged-in user can open. The role is only decided once the user has loaded, so a
 * refresh doesn't flash the 404 while the roles are still unknown.
 */
type PrivateRouteProps = {
  children: JSX.Element
  allowed?: boolean
}

export const PrivateRoute = ({ children, allowed }: PrivateRouteProps) => {
  const { isLoggedIn, currentUser } = useContext(AuthContext)
  const location = useLocation()

  if (!getToken() && !isLoggedIn) {
    // A token that is still stored but no longer usable has expired, e.g. on a reload.
    const state: LoginRouteState = {
      from: location,
      ...(getStoredToken() && {
        sessionEnded: SessionEndReason.EXPIRED,
        email: localStorage.getItem(USER_EMAIL) ?? undefined
      })
    }
    return <Navigate to={AUTH_LINKS.LOGIN_LINK} state={state} replace />
  }

  if (typeof allowed !== 'boolean') return children

  if (!currentUser) return null

  return allowed ? children : <PageNotFound />
}
